import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faSignInAlt } from '@fortawesome/free-solid-svg-icons';

const Login = ({ ipserv, onToggle, onForgot }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Email: '',
        Password: ''
    });

    const handleLogin = (e) => {
        e.preventDefault();
        setLoading(true);

        const API_BASE = ipserv || process.env.REACT_APP_API_URL || 'http://localhost:5000/';

        request.Post(API_BASE + 'auth/login', formData, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Bienvenido a DataManager' });
                localStorage.setItem('dm_admin', JSON.stringify(r.profile));
                localStorage.setItem('dm_auth_token', r.token);

                if (r.profile?.AdminRole === 'SUPERADMIN') {
                    window.location.href = '/datamanager/Core/SuperAdmin';
                } else {
                    window.location.href = '/datamanager/';
                }
            } else {
                Notify({ type: 'fail', text: r.message || r.msg || 'Credenciales incorrectas' });
            }
            setLoading(false);
        }, 'json', err => {
            Notify({ type: 'fail', text: err?.msg || 'Error de conexion' });
            setLoading(false);
        });
    };

    return (
        <div className="w-100">
            <h1 className="auth-title">Bienvenido</h1>
            <p className="auth-subtitle">Ingresa tus credenciales para acceder al panel.</p>

            <form onSubmit={handleLogin}>
                <div className="auth-input-group">
                    <input
                        type="email"
                        className="auth-input"
                        placeholder="Email corporativo"
                        value={formData.Email}
                        onChange={e => setFormData({ ...formData, Email: e.target.value })}
                        autoComplete="email"
                        required
                    />
                    <FontAwesomeIcon icon={faEnvelope} className="auth-input-icon" />
                </div>

                <div className="auth-input-group">
                    <input
                        type="password"
                        className="auth-input"
                        placeholder="Contraseña"
                        value={formData.Password}
                        onChange={e => setFormData({ ...formData, Password: e.target.value })}
                        autoComplete="current-password"
                        required
                    />
                    <FontAwesomeIcon icon={faLock} className="auth-input-icon" />
                </div>

                <div className="d-flex justify-content-end mb-4">
                    <button
                        type="button"
                        className="btn btn-link p-0 text-primary small text-decoration-none auth-forgot-link"
                        onClick={onForgot}
                        style={{ fontSize: '0.85rem', fontWeight: '500' }}
                    >
                        Restablecer contraseña
                    </button>
                </div>

                <button type="submit" className="auth-btn-primary mb-4" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : (
                        <><FontAwesomeIcon icon={faSignInAlt} /> Entrar al sistema</>
                    )}
                </button>

                <div className="text-center">
                    <p className="text-muted small mb-1">¿No tienes una cuenta aun?</p>
                    <button type="button" className="btn btn-link text-primary font-weight-bold p-0 text-decoration-none" onClick={onToggle}>
                        Registrate gratis
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Login;
